import { useCallback, useEffect, useState } from 'react';
import * as serviceWorkerRegistration from '../serviceWorkerRegistration';

function PwaManager() {
  const [waitingWorker, setWaitingWorker] = useState(null);
  const [showUpdateBanner, setShowUpdateBanner] = useState(false);
  const [installPrompt, setInstallPrompt] = useState(null);
  const [showInstallBanner, setShowInstallBanner] = useState(false);

  useEffect(() => {
    const handleControllerChange = () => {
      window.location.reload();
    };

    navigator.serviceWorker?.addEventListener('controllerchange', handleControllerChange);

    return () => {
      navigator.serviceWorker?.removeEventListener('controllerchange', handleControllerChange);
    };
  }, []);

  useEffect(() => {
    serviceWorkerRegistration.register({
      onUpdate: (registration) => {
        setWaitingWorker(registration.waiting);
        setShowUpdateBanner(true);
      },
    });
  }, []);

  useEffect(() => {
    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setInstallPrompt(event);
      setShowInstallBanner(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleUpdate = useCallback(() => {
    if (!waitingWorker) {
      window.location.reload();
      return;
    }

    waitingWorker.postMessage({ type: 'SKIP_WAITING' });
  }, [waitingWorker]);

  const handleInstall = useCallback(async () => {
    if (!installPrompt) {
      return;
    }

    installPrompt.prompt();
    await installPrompt.userChoice;
    setInstallPrompt(null);
    setShowInstallBanner(false);
  }, [installPrompt]);

  const dismissInstall = useCallback(() => {
    setShowInstallBanner(false);
  }, []);

  if (!showUpdateBanner && !showInstallBanner) {
    return null;
  }

  return (
    <div className="fixed inset-x-0 bottom-20 z-50 mx-auto w-full max-w-app px-4">
      {showUpdateBanner && (
        <div className="mb-2 flex items-center justify-between gap-3 rounded-2xl bg-[#6B2D5C] px-4 py-3 text-white shadow-lg">
          <p className="text-sm font-medium">نسخه جدید اپلیکیشن آماده است.</p>
          <button
            type="button"
            onClick={handleUpdate}
            className="shrink-0 rounded-xl bg-white px-4 py-2 text-sm font-semibold text-[#6B2D5C]"
          >
            بروزرسانی
          </button>
        </div>
      )}

      {showInstallBanner && (
        <div className="flex items-center justify-between gap-3 rounded-2xl bg-[#6B2D5C] px-4 py-3 text-white shadow-lg">
          <p className="text-sm font-medium">مدادرنگی را روی دستگاه خود نصب کنید.</p>
          <div className="flex shrink-0 gap-2">
            <button
              type="button"
              onClick={dismissInstall}
              className="rounded-xl px-3 py-2 text-sm font-medium text-white/80"
            >
              بعداً
            </button>
            <button
              type="button"
              onClick={handleInstall}
              className="rounded-xl bg-white px-4 py-2 text-sm font-semibold text-[#6B2D5C]"
            >
              نصب
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default PwaManager;
